import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/fullLogo.png";
import Select from "react-select";
import "./HeaderSimple.scss";
import "../../../assets/styles/general/select.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Header() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const defaultLanguage = "pt-BR";
  const [language, setLanguage] = useState(localStorage.getItem("language") || defaultLanguage);

  const options = [
    { value: "pt-BR", label: "PT" },
    { value: "es", label: "ES" },
    { value: "en", label: "EN" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    localStorage.removeItem("language");
    localStorage.setItem("language", lng);
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      setLanguage(savedLanguage);
    } else {
      i18n.changeLanguage(defaultLanguage);
      setLanguage(defaultLanguage);
      localStorage.setItem("language", defaultLanguage);
    }
  }, [i18n]);

  return (
    <>
      <header className="header-simple">
        <div className="container row">
          <Link to="/">
            <img src={logo} className="logo" />
          </Link>
          <Select
            options={options}
            classNamePrefix="select"
            onChange={(selectedOption) => changeLanguage(selectedOption.value)}
            value={options.find((option) => option.value === language)}
          />
        </div>
      </header>
    </>
  );
}

export default Header;
